var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pagination',{attrs:{"prev":_vm.prev,"next":_vm.next},on:{"next":function($event){_vm.setCurrentPage(_vm.nextPage)},"prev":function($event){_vm.setCurrentPage(_vm.prevPage)}}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03abf882","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/ProjectsPaginationContainer.vue
// module id = null
// module chunks = 